import { Td, Text, Tr } from "@chakra-ui/react"
import React, { Suspense } from "react"

const Modal = React.lazy(() => import("./Modal"), {
  fallback: <div>Carregando...</div>,
})

export function List({ item, refetch }) {
  return (
    <Tr>
      <Td>{item.numero_nota}</Td>
      <Td>{item.codprod}</Td>
      <Td>{item.descricao_produto}</Td>
      <Td>{item.cor}</Td>
      <Td>{item.gravacao}</Td>
      <Td>{item.observacoes}</Td>
      <Td>
        <Text
          as={"a"}
          href={item.link_layout}
          target="_blank"
          color={item.link_layout === "" ? "red.500" : "blue.500"}
          _hover={{
            filter: "brightness(0.8)",
            textDecoration: "underline",
          }}
          cursor={"pointer"}
        >
          Link Layout
        </Text>
      </Td>
      <Td>
        <Suspense fallback={<div>Carregando...</div>}>
          <Modal item={item} refetch={refetch} />
        </Suspense>
      </Td>
    </Tr>
  )
}
